"use client";

import React from "react";
import { LeadFormEncodedTemplate } from "../../components/LeadFormEncodedTemplate";
import { LeadFormFootnote } from "../../components/LeadFormFootnote";
import { LeadFormPluginScript } from "../../components/LeadFormPluginScript";
import { LeadFormIntegratedProps } from "../../LeadFormIntegrated.types";
import { useLeadFormIntegrated } from "../../useLeadFormIntegrated";
import styles from "./Default.module.scss";

export const Default: React.FC<LeadFormIntegratedProps> = ({
  className,
  loadedClassName = "",
  packageId = "",
  enableStyles = true,
  enableMultiColumn = false,
  leadFormType = "TY",
  footnote,
  isLoading,
  thankYouURL,
  showFormHeader = false,
  isDrawerOpen = false,
  title,
  subtitle,
  applyDomain = "",
  phoneNumber,
  parseMetadata,
  location,
  formType,
  variation: _variation,
  onStepChange,
  ...rest
}) => {
  const {
    formContainerRef,
    isLastStep,
    loaded,
    setLoaded,
    formId,
    salt,
    finalTitle,
    finalSubtitle,
    getMountClassName,
  } = useLeadFormIntegrated({
    packageId,
    applyDomain,
    leadFormType,
    thankYouURL,
    isDrawerOpen,
    title,
    subtitle,
    location,
    onStepChange,
  });

  return (
    <div className={className} ref={formContainerRef}>
      <LeadFormEncodedTemplate
        salt={salt}
        finalTitle={finalTitle}
        finalSubtitle={finalSubtitle}
        showFormHeader={showFormHeader}
      />
      {!isLoading && (
        <>
          <div
            {...rest}
            id={formId}
            className={getMountClassName({
              styles,
              loadedClassName,
              loaded,
              enableStyles,
              enableMultiColumn,
              leadFormType,
              isLastStep,
            })}
            data-form-type={formType}
          />
          {footnote && (
            <LeadFormFootnote
              footnote={footnote}
              parseMetadata={parseMetadata}
              phoneNumber={phoneNumber}
              isLastStep={!!isLastStep}
              styles={styles}
            />
          )}
          <LeadFormPluginScript salt={salt} onLoad={() => setLoaded(true)} />
        </>
      )}
    </div>
  );
};
